/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Menu configuration
 */
import { FAQ_CATEGORIES, PAGE_ROLES } from './index';
import { ROUTES, PAGE_KEYS, ICON_MAP, SEARCH_META, PAGE_TITLE, FEATURES } from './routes';

const DEFAULT_SECTION_PROPS: Pick<Menu.Item, 'disabled' | 'component' | 'icon' | 'search' | 'faqCategories' | 'roles'> = {
	disabled: false,
	component: 'PageNotFound',
	icon: ICON_MAP.default,
	search: SEARCH_META.default,
	faqCategories: [], // TODO
	roles: [],
};

/**
 * App menu configuration
 * Dynamic required param like /:id in the url path must be only added in extra routes
 * Dynamic optional param like /:tab? in the url path can be added in routes (pages)
 * extraRoutes will not be rendered in the sidebar & its child routes will be ignored
 */
const app: Menu.Item[] = [
	{
		...DEFAULT_SECTION_PROPS,
		feature: FEATURES.eligibility.key,
		name: FEATURES.eligibility.title,
		key: PAGE_KEYS.eligibility.section,
		path: ROUTES.eligibility.landing,
		routes: [
			{
				disabled: false,
				feature: FEATURES.eligibility.key,
				key: PAGE_KEYS.eligibility.responses,
				path: ROUTES.eligibility.responses,
				roles: PAGE_ROLES.eligibility.responses,
				icon: ICON_MAP.eligibility.responses,
				search: SEARCH_META.eligibility.responses,
				name: PAGE_TITLE.eligibility.responses,
				component: 'EligibilityRequests',
				faqCategories: [FAQ_CATEGORIES.Eligibility.category],
				extraRoutes: [
					{
						disabled: false,
						feature: FEATURES.eligibility.key,
						key: PAGE_KEYS.eligibility.newRequest,
						path: ROUTES.eligibility.newRequest,
						roles: PAGE_ROLES.eligibility.newRequest,
						icon: ICON_MAP.eligibility.newRequest,
						search: SEARCH_META.eligibility.newRequest,
						name: PAGE_TITLE.eligibility.newRequest,
						component: 'EligibilityRequestForm',
						faqCategories: [FAQ_CATEGORIES.Eligibility.category],
					},
					{
						disabled: false,
						feature: FEATURES.eligibility.key,
						key: PAGE_KEYS.eligibility.viewResponse,
						path: ROUTES.eligibility.viewResponse,
						roles: PAGE_ROLES.eligibility.viewResponse,
						icon: ICON_MAP.eligibility.viewResponse,
						search: SEARCH_META.eligibility.viewResponse,
						name: PAGE_TITLE.eligibility.viewResponse,
						component: 'EligibilityResponse',
						faqCategories: [FAQ_CATEGORIES.Eligibility.category],
					},
					{
						disabled: false,
						feature: FEATURES.eligibility.key,
						key: PAGE_KEYS.eligibility.editRequest,
						path: ROUTES.eligibility.editRequest,
						roles: PAGE_ROLES.eligibility.editRequest,
						icon: ICON_MAP.eligibility.editRequest,
						search: SEARCH_META.eligibility.editRequest,
						name: PAGE_TITLE.eligibility.editRequest,
						component: 'EligibilityRequestForm',
						faqCategories: [FAQ_CATEGORIES.Eligibility.category],
					},
					{
						disabled: false,
						feature: FEATURES.eligibility.key,
						key: PAGE_KEYS.eligibility.batch.viewResponse,
						path: ROUTES.eligibility.batch.viewResponse,
						roles: PAGE_ROLES.eligibility.batch.viewResponse,
						icon: ICON_MAP.eligibility.batch.viewResponse,
						search: SEARCH_META.eligibility.batch.viewResponse,
						name: PAGE_TITLE.eligibility.batch.viewResponse,
						component: 'EligibilityBatchResponse',
						faqCategories: [FAQ_CATEGORIES.Eligibility.category],
					},
					{
						disabled: false,
						feature: FEATURES.eligibility.key,
						key: PAGE_KEYS.eligibility.batch.add,
						path: ROUTES.eligibility.batch.add,
						roles: PAGE_ROLES.eligibility.batch.add,
						icon: ICON_MAP.eligibility.batch.add,
						search: SEARCH_META.eligibility.batch.add,
						name: PAGE_TITLE.eligibility.batch.add,
						component: 'EligibilityBatchUpload',
						faqCategories: [FAQ_CATEGORIES.Eligibility.category],
					},
					{
						disabled: false,
						feature: FEATURES.eligibility.key,
						key: PAGE_KEYS.eligibility.batch.edit,
						path: ROUTES.eligibility.batch.edit,
						roles: PAGE_ROLES.eligibility.batch.edit,
						icon: ICON_MAP.eligibility.batch.edit,
						search: SEARCH_META.eligibility.batch.edit,
						name: PAGE_TITLE.eligibility.batch.edit,
						component: 'EligibilityBatchUpload',
						faqCategories: [FAQ_CATEGORIES.Eligibility.category],
					},
				],
			},
		],
	},
	{
		...DEFAULT_SECTION_PROPS,
		feature: FEATURES.claims.key,
		name: FEATURES.claims.title,
		key: PAGE_KEYS.claims.section,
		path: ROUTES.claims.landing,
		routes: [
			{
				disabled: false,
				feature: FEATURES.claims.key,
				key: PAGE_KEYS.claims.responses,
				path: ROUTES.claims.responses,
				roles: PAGE_ROLES.claims.responses,
				icon: ICON_MAP.claims.responses,
				search: SEARCH_META.claims.responses,
				name: PAGE_TITLE.claims.responses,
				component: 'ClaimStatusRequests',
				faqCategories: [FAQ_CATEGORIES.ClaimStatus.category],
				extraRoutes: [
					{
						disabled: false,
						feature: FEATURES.claims.key,
						key: PAGE_KEYS.claims.newRequest,
						path: ROUTES.claims.newRequest,
						roles: PAGE_ROLES.claims.newRequest,
						icon: ICON_MAP.claims.newRequest,
						search: SEARCH_META.claims.newRequest,
						name: PAGE_TITLE.claims.newRequest,
						component: 'ClaimStatusRequestForm',
						faqCategories: [FAQ_CATEGORIES.ClaimStatus.category],
					},
					{
						disabled: false,
						feature: FEATURES.claims.key,
						key: PAGE_KEYS.claims.viewResponse,
						path: ROUTES.claims.viewResponse,
						roles: PAGE_ROLES.claims.viewResponse,
						icon: ICON_MAP.claims.viewResponse,
						search: SEARCH_META.claims.viewResponse,
						name: PAGE_TITLE.claims.viewResponse,
						component: 'ClaimStatusResponse',
						faqCategories: [FAQ_CATEGORIES.ClaimStatus.category],
					},
					{
						disabled: false,
						feature: FEATURES.claims.key,
						key: PAGE_KEYS.claims.editRequest,
						path: ROUTES.claims.editRequest,
						roles: PAGE_ROLES.claims.editRequest,
						icon: ICON_MAP.claims.editRequest,
						search: SEARCH_META.claims.editRequest,
						name: PAGE_TITLE.claims.editRequest,
						component: 'ClaimStatusRequestForm',
						faqCategories: [FAQ_CATEGORIES.ClaimStatus.category],
					},
				],
			},
		],
	},
	// {
	// 	...DEFAULT_SECTION_PROPS,
	// 	feature: FEATURES.payments.key,
	// 	name: FEATURES.payments.title,
	// 	key: PAGE_KEYS.payments.section,
	// 	path: ROUTES.payments.landing,
	// 	routes: [
	// 		{
	// 			disabled: false,
	// 			feature: FEATURES.payments.key,
	// 			key: PAGE_KEYS.payments.submissions,
	// 			path: ROUTES.payments.submissions,
	// 			roles: PAGE_ROLES.payments.submissions,
	// 			icon: ICON_MAP.payments.submissions,
	// 			search: SEARCH_META.payments.submissions,
	// 			name: PAGE_TITLE.payments.submissions,
	// 			component: 'PaymentSubmissions',
	// 			faqCategories: [FAQ_CATEGORIES.Payments.category], // TODO
	// 			extraRoutes: [
	// 				{
	// 					disabled: false,
	// 					feature: FEATURES.payments.key,
	// 					key: PAGE_KEYS.payments.request,
	// 					path: ROUTES.payments.request,
	// 					roles: PAGE_ROLES.payments.request,
	// 					icon: ICON_MAP.payments.request,
	// 					search: SEARCH_META.payments.request,
	// 					name: PAGE_TITLE.payments.request,
	// 					component: 'PaymentRequest',
	// 					faqCategories: [FAQ_CATEGORIES.Payments.category], // TODO
	// 				},
	// 				{
	// 					disabled: false,
	// 					feature: FEATURES.payments.key,
	// 					key: PAGE_KEYS.payments.quickPay,
	// 					path: ROUTES.payments.quickPay,
	// 					roles: PAGE_ROLES.payments.quickPay,
	// 					icon: ICON_MAP.payments.quickPay,
	// 					search: SEARCH_META.payments.quickPay,
	// 					name: PAGE_TITLE.payments.quickPay,
	// 					component: 'QuickPayment',
	// 					faqCategories: [FAQ_CATEGORIES.Payments.category], // TODO
	// 				},
	// 			],
	// 		},
	// 	],
	// },
	{
		...DEFAULT_SECTION_PROPS,
		feature: FEATURES.codeExplorer.key,
		name: FEATURES.codeExplorer.title,
		key: PAGE_KEYS.codeExplorer.section,
		path: ROUTES.codeExplorer.landing,
		routes: [
			{
				disabled: false,
				feature: FEATURES.codeExplorer.key,
				key: PAGE_KEYS.codeExplorer.allCodes,
				path: ROUTES.codeExplorer.allCodes,
				name: PAGE_TITLE.codeExplorer.allCodes,
				icon: ICON_MAP.codeExplorer.allCodes,
				component: 'CodeExplorer',
				search: SEARCH_META.codeExplorer.allCodes,
				roles: PAGE_ROLES.codeExplorer.allCodes,
				faqCategories: [FAQ_CATEGORIES.CodeExplorer.category], // TODO
				extraRoutes: [
					{
						disabled: false,
						feature: FEATURES.codeExplorer.key,
						key: PAGE_KEYS.codeExplorer.searchResults,
						path: ROUTES.codeExplorer.searchResults,
						roles: PAGE_ROLES.codeExplorer.searchResults,
						name: PAGE_TITLE.codeExplorer.searchResults,
						icon: ICON_MAP.codeExplorer.searchResults,
						component: 'SearchResults',
						search: SEARCH_META.codeExplorer.searchResults,
						faqCategories: [FAQ_CATEGORIES.CodeExplorer.category], // TODO
					},
					{
						disabled: false,
						feature: FEATURES.codeExplorer.key,
						key: PAGE_KEYS.codeExplorer.codeSetSearchResults,
						path: ROUTES.codeExplorer.codeSetSearchResults,
						roles: PAGE_ROLES.codeExplorer.searchResults,
						name: PAGE_TITLE.codeExplorer.searchResults,
						icon: ICON_MAP.codeExplorer.searchResults,
						component: 'SearchResults',
						search: SEARCH_META.codeExplorer.searchResults,
						faqCategories: [FAQ_CATEGORIES.CodeExplorer.category], // TODO
					},
					{
						disabled: false,
						feature: FEATURES.codeExplorer.key,
						key: PAGE_KEYS.codeExplorer.codeDetails,
						path: ROUTES.codeExplorer.codeDetails,
						roles: PAGE_ROLES.codeExplorer.codeDetails,
						name: PAGE_TITLE.codeExplorer.codeDetails,
						icon: ICON_MAP.codeExplorer.codeDetails,
						component: 'DetailedCodeView',
						search: SEARCH_META.codeExplorer.codeDetails,
						faqCategories: [FAQ_CATEGORIES.CodeExplorer.category], // TODO
					},
					{
						disabled: false,
						feature: FEATURES.codeExplorer.key,
						key: PAGE_KEYS.codeExplorer.codeList,
						path: ROUTES.codeExplorer.codeList,
						roles: PAGE_ROLES.codeExplorer.codeList,
						name: PAGE_TITLE.codeExplorer.codeList,
						icon: ICON_MAP.codeExplorer.codeList,
						component: 'ICD10PCSLookup',
						search: SEARCH_META.codeExplorer.codeList,
						faqCategories: [FAQ_CATEGORIES.CodeExplorer.category], // TODO
					},
				],
			},
			{
				disabled: false,
				feature: FEATURES.codeExplorer.key,
				key: PAGE_KEYS.codeExplorer.favoriteCodes,
				path: ROUTES.codeExplorer.favoriteCodes,
				name: PAGE_TITLE.codeExplorer.favoriteCodes,
				icon: ICON_MAP.codeExplorer.favoriteCodes,
				component: 'FavoriteCodes',
				search: SEARCH_META.codeExplorer.favoriteCodes,
				roles: PAGE_ROLES.codeExplorer.favoriteCodes,
				faqCategories: [FAQ_CATEGORIES.CodeExplorer.category], // TODO
			},
		],
	},
];

/**
 * Settings menu configuration
 * Dynamic required param like /:id in the url path must be only added in extra routes
 * Dynamic optional param like /:tab? in the url path can be added in routes (pages)
 * extraRoutes will not be rendered in the sidebar & its child routes will be ignored
 */
const settings: Menu.Item[] = [
	{
		...DEFAULT_SECTION_PROPS,
		feature: FEATURES.settings.key,
		key: PAGE_KEYS.settings.organization.section,
		path: ROUTES.settings.organization.landing,
		name: 'Organization',
		routes: [
			{
				disabled: false,
				feature: FEATURES.settings.key,
				key: PAGE_KEYS.settings.organization.general,
				path: ROUTES.settings.organization.general,
				roles: PAGE_ROLES.settings.organization.general,
				icon: ICON_MAP.settings.organization.general,
				search: SEARCH_META.settings.organization.general,
				name: PAGE_TITLE.settings.organization.general,
				component: 'GeneralSettings',
				faqCategories: [], // TODO
			},
			{
				disabled: false,
				feature: FEATURES.settings.key,
				key: PAGE_KEYS.settings.organization.users.listView,
				path: ROUTES.settings.organization.users.listView,
				roles: PAGE_ROLES.settings.organization.users.listView,
				icon: ICON_MAP.settings.organization.users.listView,
				search: SEARCH_META.settings.organization.users.listView,
				name: PAGE_TITLE.settings.organization.users.listView,
				component: 'UserManagement',
				faqCategories: [], // TODO
				extraRoutes: [
					{
						disabled: false,
						feature: FEATURES.settings.key,
						key: PAGE_KEYS.settings.organization.users.add,
						path: ROUTES.settings.organization.users.add,
						roles: PAGE_ROLES.settings.organization.users.add,
						icon: ICON_MAP.settings.organization.users.add,
						search: SEARCH_META.settings.organization.users.add,
						name: PAGE_TITLE.settings.organization.users.add,
						component: 'UserManagementForm',
						faqCategories: [], // TODO
					},
					{
						disabled: false,
						feature: FEATURES.settings.key,
						key: PAGE_KEYS.settings.organization.users.edit,
						path: ROUTES.settings.organization.users.edit,
						roles: PAGE_ROLES.settings.organization.users.edit,
						icon: ICON_MAP.settings.organization.users.edit,
						search: SEARCH_META.settings.organization.users.edit,
						name: PAGE_TITLE.settings.organization.users.edit,
						component: 'UserManagementForm',
						faqCategories: [], // TODO
					},
				],
			},
			{
				disabled: false,
				feature: FEATURES.settings.key,
				key: PAGE_KEYS.settings.organization.subscriptions,
				path: ROUTES.settings.organization.subscriptions,
				roles: PAGE_ROLES.settings.organization.subscriptions,
				icon: ICON_MAP.settings.organization.subscriptions,
				search: SEARCH_META.settings.organization.subscriptions,
				name: PAGE_TITLE.settings.organization.subscriptions,
				component: 'Accounts',
				faqCategories: [], // TODO
			},
			{
				disabled: false,
				feature: FEATURES.settings.key,
				key: PAGE_KEYS.settings.organization.auditLogs,
				path: ROUTES.settings.organization.auditLogs,
				roles: PAGE_ROLES.settings.organization.auditLogs,
				icon: ICON_MAP.settings.organization.auditLogs,
				search: SEARCH_META.settings.organization.auditLogs,
				name: PAGE_TITLE.settings.organization.auditLogs,
				component: 'AuditLogs',
				faqCategories: [], // TODO
			},
		],
	},
	{
		...DEFAULT_SECTION_PROPS,
		feature: FEATURES.settings.key,
		key: PAGE_KEYS.settings.dataManagement.section,
		path: ROUTES.settings.dataManagement.landing,
		name: 'Data Management',
		routes: [
			{
				disabled: false,
				feature: FEATURES.settings.key,
				key: PAGE_KEYS.settings.dataManagement.providers.listView,
				path: ROUTES.settings.dataManagement.providers.listView,
				roles: PAGE_ROLES.settings.dataManagement.providers.listView,
				icon: ICON_MAP.settings.dataManagement.providers.listView,
				search: SEARCH_META.settings.dataManagement.providers.listView,
				name: PAGE_TITLE.settings.dataManagement.providers.listView,
				component: 'Providers',
				faqCategories: [FAQ_CATEGORIES.Provider.category],
				extraRoutes: [
					{
						disabled: false,
						feature: FEATURES.settings.key,
						key: PAGE_KEYS.settings.dataManagement.providers.add,
						path: ROUTES.settings.dataManagement.providers.add,
						roles: PAGE_ROLES.settings.dataManagement.providers.add,
						icon: ICON_MAP.settings.dataManagement.providers.add,
						search: SEARCH_META.settings.dataManagement.providers.add,
						name: PAGE_TITLE.settings.dataManagement.providers.add,
						component: 'ProviderForm',
						faqCategories: [FAQ_CATEGORIES.Provider.category],
					},
					{
						disabled: false,
						feature: FEATURES.settings.key,
						key: PAGE_KEYS.settings.dataManagement.providers.edit,
						path: ROUTES.settings.dataManagement.providers.edit,
						roles: PAGE_ROLES.settings.dataManagement.providers.edit,
						icon: ICON_MAP.settings.dataManagement.providers.edit,
						search: SEARCH_META.settings.dataManagement.providers.edit,
						name: PAGE_TITLE.settings.dataManagement.providers.edit,
						component: 'ProviderForm',
						faqCategories: [FAQ_CATEGORIES.Provider.category],
					},
				],
			},
			{
				disabled: false,
				feature: FEATURES.settings.key,
				key: PAGE_KEYS.settings.dataManagement.locations.listView,
				path: ROUTES.settings.dataManagement.locations.listView,
				roles: PAGE_ROLES.settings.dataManagement.locations.listView,
				icon: ICON_MAP.settings.dataManagement.locations.listView,
				search: SEARCH_META.settings.dataManagement.locations.listView,
				name: PAGE_TITLE.settings.dataManagement.locations.listView,
				component: 'Locations',
				faqCategories: [], // TODO
				extraRoutes: [
					{
						disabled: false,
						feature: FEATURES.settings.key,
						key: PAGE_KEYS.settings.dataManagement.locations.add,
						path: ROUTES.settings.dataManagement.locations.add,
						roles: PAGE_ROLES.settings.dataManagement.locations.add,
						icon: ICON_MAP.settings.dataManagement.locations.add,
						search: SEARCH_META.settings.dataManagement.locations.add,
						name: PAGE_TITLE.settings.dataManagement.locations.add,
						component: 'LocationForm',
						faqCategories: [], // TODO
					},
					{
						disabled: false,
						feature: FEATURES.settings.key,
						key: PAGE_KEYS.settings.dataManagement.locations.edit,
						path: ROUTES.settings.dataManagement.locations.edit,
						roles: PAGE_ROLES.settings.dataManagement.locations.edit,
						icon: ICON_MAP.settings.dataManagement.locations.edit,
						search: SEARCH_META.settings.dataManagement.locations.edit,
						name: PAGE_TITLE.settings.dataManagement.locations.edit,
						component: 'LocationForm',
						faqCategories: [], // TODO
					},
				],
			},
			{
				disabled: false,
				feature: FEATURES.settings.key,
				key: PAGE_KEYS.settings.dataManagement.payers.listView,
				path: ROUTES.settings.dataManagement.payers.listView,
				roles: PAGE_ROLES.settings.dataManagement.payers.listView,
				icon: ICON_MAP.settings.dataManagement.payers.listView,
				search: SEARCH_META.settings.dataManagement.payers.listView,
				name: PAGE_TITLE.settings.dataManagement.payers.listView,
				component: 'Payers',
				faqCategories: [FAQ_CATEGORIES.Payer.category],
				extraRoutes: [
					{
						disabled: false,
						feature: FEATURES.settings.key,
						key: PAGE_KEYS.settings.dataManagement.payers.edit,
						path: ROUTES.settings.dataManagement.payers.edit,
						roles: PAGE_ROLES.settings.dataManagement.payers.edit,
						icon: ICON_MAP.settings.dataManagement.payers.edit,
						search: SEARCH_META.settings.dataManagement.payers.edit,
						name: PAGE_TITLE.settings.dataManagement.payers.edit,
						component: 'EligibilityPayerSettings',
						faqCategories: [FAQ_CATEGORIES.Payer.category],
					},
				],
			},
		],
	},
	// {
	// 	...DEFAULT_SECTION_PROPS,
	// 	feature: FEATURES.settings.key,
	// 	key: PAGE_KEYS.settings.integration.section,
	// 	path: ROUTES.settings.integration.landing,
	// 	name: 'Integration',
	// 	routes: [
	// 		{
	// 			disabled: false,
	// 			feature: FEATURES.settings.key,
	// 			key: PAGE_KEYS.settings.integration.payment,
	// 			path: ROUTES.settings.integration.payment,
	// 			roles: PAGE_ROLES.settings.integration.payment,
	// 			search: SEARCH_META.settings.integration.payment,
	// 			name: 'Payment',
	// 			icon: ICON_MAP.settings.integration.payment,
	// 			component: 'PaymentSettings',
	// 			faqCategories: [], // TODO
	// 		},
	// 	],
	// },
];

const help: Menu.Item = {
	disabled: false,
	feature: FEATURES.help.key,
	key: PAGE_KEYS.help.landing,
	name: PAGE_TITLE.help.landing,
	path: ROUTES.help.landing,
	roles: PAGE_ROLES.help.landing,
	icon: ICON_MAP.help.landing,
	search: SEARCH_META.help.landing,
	component: 'UserHelp',
	isExtraRoute: true,
	faqCategories: [], // TODO
};

export { DEFAULT_SECTION_PROPS };
export default { app, settings, help };
